import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import useDataBean from '../../core/services/dataBean/useDataBean';
import { _DocumentFactory } from '../../core/services/dataBean/EntityCatalog';

interface Props {
    idSelector: string;
    onChange: any;
    label?: string;
    idDocumentTemplate: number;
}

export const SelectDocumentTemplateFileType = ({ idSelector, onChange, label, idDocumentTemplate }: Props) => {

    const { lista, setLista, instance } = useDataBean(_DocumentFactory)
    const [id, setID] = useState<string>("");

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        if (idDocumentTemplate) {
            getLista();
        }
    }, [idDocumentTemplate])

    const setValue = (e: string) => {
        const selectedId = e;
        setID(selectedId);
        if (onChange) {
            onChange(selectedId);
        }
    };

    const getLista = () => {
        instance.getDocumentTemplateFileTypeList(idDocumentTemplate).then(
            (resp: any) => {
                setLista(resp);
                if (resp.length == 1) {
                    setID(resp[0]);
                    onChange(resp[0])
                }
            }
        ).catch(err => { toast.error(err) })
    }

    return (
        <>
            <label>{label ?? "Tipo de Documento"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={""}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item} >{item}</option>
                        )
                    })
                }
            </select>
        </>
    )
}